// extracted by mini-css-extract-plugin
export default {"item":"RepPovSwitch_item__QAv3i"};